import {Label} from 'platform/components';

import {useGetCurrentUserInfoQuery} from '@dms/api/customer';
import i18n from '@dms/i18n';
import {UserExternalSystems} from '@dms/shared';

import {MyProfileTemplate} from '../../components/MyProfileTemplate/MyProfileTemplate';

export function ExternalSystems() {
  const {data: user, isError, isLoading} = useGetCurrentUserInfoQuery();

  return (
    <MyProfileTemplate
      header={{
        title: i18n.t('page.employeeDetail.labels.externalAuthorizationSystem'),
        breadcrumbs: [
          {label: i18n.t('entity.user.labels.myProfile'), isCurrentPage: true},
          {
            label: i18n.t('page.employeeDetail.labels.externalAuthorizationSystem'),
            isCurrentPage: true,
          },
        ],
      }}
      isError={isError}
      isLoading={isLoading}
    >
      <Label>{i18n.t('page.myProfile.labels.externalSystemsDescription')}</Label>

      <UserExternalSystems userId={user?.id} />
    </MyProfileTemplate>
  );
}
